<template>
  <!-- Dummy contents -->
  <span />
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      validator(val) {
        return ['brain', 'studio'].includes(val)
      },
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
  },
  async created() {
    let contents
    window.document.open()
    try {
      contents = await this.viewer(this.id, this.type)
      window.document.write(contents.data)
    } catch (error) {
      window.document.write(
        '<h1>' + this.getCommonErrorMessage(error) + '</h1>'
      )
    }
    window.document.close()
  },
}
</script>
